import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import packageJson from "../../../../package.json";
import axios from "axios";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}));

export default function CustomizedSelects() {
  const [Countries, setCountries] = useState([]);
  const [city, setCity] = useState([]);
  const [zone, setZone] = useState([]);
  const [city_id, setcity_id] = useState("1");
  const [city_id2, setcity_id2] = useState({
    city: {
      value: "",
    },
  });

  const handel = (e) => {
    e.persist();
    setcity_id2({ ...city_id2, [e.target.name]: e.target.value });
  };

  const handleSubmit1 = (e) => {
    e.preventDefault();

    axios
      .get(
        `${BaseUrl}/api/country/${city_id}/city/${city_id2.city}/zones`,
        { withCredentials: true }
      )
      .then((resZone) => {
        setZone(resZone.data.data);
      });
  };
  useEffect(() => {
    const config = {
      headers: { "Content-Type": "application/json", Authorization: null },
    };
    axios
      .get(
        `${BaseUrl}/sanctum/csrf-cookie`,
        config
      )
      .then((response) => {
        axios
          .get(
            `${BaseUrl}/api/countries`,
            {
              withCredentials: true,
            }
          )
          .then((res) => {
            setCountries(res.data.data);

            setcity_id(res.data.data[0].id);
            axios
              .get(
                `${BaseUrl}/api/country/${city_id}/cities`,
                {
                  withCredentials: true,
                }
              )
              .then((rescities) => {
                setCity(rescities.data.data);
              });
          });
      });
  }, []);

  return (
    <div>
      <div>
        <select onChange={handel} name="city">
          {city.map((opts, i) => (
            <option key={i} onClick={handleSubmit1} value={opts.id}>
              {opts.name_ar}
            </option>
          ))}
        </select>
      </div>
      <div>
        <select onChange={handel} name="zone">
          {zone.map((opts, i) => (
            <option key={opts} value={i}>
              {opts.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
